<div class="flex justify-content-between align-items-center">
  <div class="ml-3 font-semibold text-l">{{ config?.label }}</div>
  <p-button
    text
    small
    [disabled]="createButtonDisabled"
    [label]="config?.createButtonLabel ?? 'Προσθήκη Νέου'"
    [icon]="config?.createButtonIcon ?? 'pi pi-plus'"
    [styleClass]="config?.createButtonStyleClass"
    (onClick)="onCreateButtonClick()"
  />
</div>

@if(config?.tableData?.length != 0) {
<p-table [value]="config?.tableData ?? []">
  <ng-template pTemplate="header">
    <tr class="th-bg-gray-50 th-font-semibold">
      <th *ngFor="let prop of config?.formFields">
        {{ prop.label }}
      </th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
    <tr>
      <td *ngFor="let prop of config?.formFields">
        @if(item?.[prop.fieldId]?.fileUrl != undefined){
        <a
          *ngIf="item?.[prop.fieldId]"
          href="{{ item?.[prop.fieldId]?.fileUrl }}"
          target="_blank"
        >
          {{ item?.[prop.fieldId]?.fileName}}
        </a>
        } @else{
        {{ item?.[prop.fieldId] }}}
      </td>
      <td>
        <p-button
          text
          icon="pi pi-trash"
          severity="danger"
          [loading]="deleteLoading"
          [disabled]="deleteLoading"
          (onClick)="onDelete(item)"
        />
      </td>
    </tr>
  </ng-template>
</p-table>
}
<!--  -->
@if (formConfig) {
<eo-form-dialog
  #eoFormDialog
  [(visible)]="formDialogVisible"
  [formConfig]="formConfig"
  [header]="config?.formHeader ?? ''"
  [submitLoading]="submitLoading"
  (onSubmit)="onFormSubmit($event)"
/>
}
